"use client"

import { ArrowRight, Play } from "lucide-react"
import { buttonClassName } from "@/components/ui/button"
import { StarfieldBackground } from "@/components/ui/starfield"
import { useInView } from "@/hooks/use-in-view"
import { cn } from "@/lib/utils"

export function Hero() {
  const { ref: titleRef, isInView: titleInView } =
    useInView<HTMLHeadingElement>()

  return (
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-10">
        <StarfieldBackground position="absolute" className="z-0" />
        <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8 py-16 lg:py-24">
          <div className="mx-auto max-w-6xl text-center">

            {/* Main headline */}
            <h1
              ref={titleRef}
              className={cn(
                "font-anton-sc text-5xl sm:text-7xl lg:text-8xl xl:text-8xl tracking-tight leading-none transition-all duration-1000 ease-out will-change-transform",
                "motion-reduce:transition-none motion-reduce:transform-none",
                titleInView
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-3",
              )}
            >
              <span className="uppercase mt-2 block text-5xl sm:text-7xl lg:text-7xl xl:text-8xl text-titulo-hero">Entendemos como trabajas</span>
              <span className="uppercase mt-2 block text-5xl sm:text-7xl lg:text-7xl xl:text-8xl text-titulo-hero"> y te ayudamos a hacerlo mejor</span>
            </h1>

            {/* Subheadline */}
            <p
              className={cn(
                "font-jetbrains font-extralight mt-6 text-lg sm:text-xl text-titulo-hero/70 max-w-4xl mx-auto leading-relaxed text-pretty transition-all duration-1000 ease-out will-change-transform",
                "motion-reduce:transition-none motion-reduce:transform-none",
                titleInView
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-3",
              )}
            >
              Desarrollamos aplicaciones que transforman tu forma de trabajar.
              Analizamos tus procesos, detectamos oportunidades de mejora y creamos soluciones a medida que impulsan tu eficiencia y crecimiento.
            </p>

            {/* CTA Buttons */}
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
              <a href="#contacto" className={buttonClassName("primary", "group")}>
                Solicitar análisis gratuito
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </a>
              <a
                href="#proceso"
                className={buttonClassName(
                  "outline",
                  "group text-titulo-hero border-border bg-transparent hover:bg-secondary/50",
                )}
              >
                <Play className="mr-2 h-4 w-4" />
                Ver cómo funciona
              </a>
            </div>
          </div>
        </div>
      </section>
  )
}
